// extracted by mini-css-extract-plugin
export default {"IEEEAAST":"Footer_IEEEAAST__O-UWL"};